import React from "react";

export const LoginForm = ({ setEmail, handleSubmit, handleGoogleLogin, loading }) => {
    return (
        <>
            <div className="text-center mb-6">
                <div className="flex items-center justify-center mb-3">
                    <i className="fas fa-sign-in-alt text-blue-600 text-lg"></i>
                </div>
                <h2 className="text-xl font-semibold text-gray-800 mb-2">Iniciar Sesión</h2>
                <p className="text-gray-600 text-sm">
                    Ingresa tu correo electrónico para acceder a tus tareas
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <i className="fas fa-envelope text-gray-400"></i>
                    </div>
                    <input
                        type="email"
                        name="email"
                        placeholder="tucorreo@ejemplo.com"
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-2
                    ${
                        loading
                            ? "bg-blue-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700 hover:shadow-lg transform hover:scale-105"
                    } text-white`}
                >
                    {loading ? (
                        <>
                            <i className="fas fa-spinner animate-spin"></i>
                            <span>Enviando enlace...</span>
                        </>
                    ) : (
                        <>
                            <i className="fas fa-paper-plane"></i>
                            <span>Enviar enlace de acceso</span>
                        </>
                    )}
                </button>
            </form>

            {/* Divisor Visual "O" */}
            <div className="relative my-6 flex items-center justify-center">
                <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                </div>
                <span className="relative px-3 bg-white text-xs text-gray-400 uppercase font-medium tracking-wider">
                    o
                </span>
            </div>

            {/* Botón de Google (Frontend Únicamente) */}
            <button
                type="button"
                onClick={handleGoogleLogin} // <-- Conectamos la función aquí
                className="w-full py-3 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-3 shadow-sm hover:shadow transform hover:scale-105"
            >
                {/* SVG de la G de Google Multicolor */}
                <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        fill="#4285F4"
                    />
                    <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                    />
                    <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.53 12-4.53z"
                        fill="#EA4335"
                    />
                </svg>
                <span>Continuar con Google</span>
            </button>

            <div className="mt-6 p-3 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-start space-x-2">
                    <i className="fas fa-info-circle text-blue-600 mt-1 text-sm"></i>
                    <div className="text-xs text-blue-800">
                        <p className="font-medium mb-1">¿Cómo funciona?</p>
                        <p>Te enviaremos un enlace seguro a tu correo o puedes usar tu cuenta de Google.</p>
                    </div>
                </div>
            </div>
        </>
    );
};